import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

export function useChangeCanvasOwner(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const { mutateAsync, isPending, error, isSuccess, isError } =
    trpc.canvas.changeOwner.useMutation({
      onMutate: ({ canvasId, ownerId }) => {
        utils.canvas.search.cancel();

        utils.canvas.search.setData({}, (old: any) => {
          if (!old?.results) {
            return old;
          }

          return {
            ...old,
            results: old.results.map((canvas: any) => {
              if (canvas.id === canvasId) {
                return {
                  ...canvas,
                  ownerId: Number(ownerId),
                };
              }
              return canvas;
            }),
          };
        });
      },

      onSettled: () => {
        utils.canvas.search.invalidate();
        utils.permission.checkPermissions.invalidate();
        if (folderId) {
          utils.asset.getHydratedFolderAssets.invalidate({
            folderId,
          });
        }
      },
    });

  return {
    changeCanvasOwner: mutateAsync,
    error,
    isError,
    isLoading: isPending,
    isPending,
    isSuccess,
  };
}
